import {
	GET_OPERATION_SCHEDULE_COLABORATORS,
	GET_OPERATION_SCHEDULE_COLABORATORS_ERROR,
	GET_OPERATION_SCHEDULE_COLABORATORS_SUCCESS,
} from '../../../constants';

export const getScheduleCollaboratorReducer = (state, actions) => {
	switch (actions.type) {
		case GET_OPERATION_SCHEDULE_COLABORATORS:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_OPERATION_SCHEDULE_COLABORATORS_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_OPERATION_SCHEDULE_COLABORATORS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				schedules: actions.payload,
			};
		default:
			return state;
	}
};
